
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'embedded-viral-link-ui',
  currentProjectVersion: 'static-1.6453',
  depVersions: {
  "embedded-viral-link-ui": "static-1.6453",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8046",
  "hubspot-dlb": "static-2.1854",
  "HubStyleTokens": "static-2.11504",
  "I18n": "static-7.1631",
  "jasmine-runner": "static-1.6495",
  "quartz": "static-1.7069",
  "quartz-core": "static-1.6288",
  "react-dlb": "static-1.79",
  "webpack-env": "static-1.54",
  "cssUtils": "static-1.798",
  "enviro": "static-4.455",
  "foundations-components": "static-1.7994",
  "hub-http": "static-1.6254",
  "hubspot-url-utils": "static-1.4132",
  "HubStyle": "static-2.11811",
  "icons": "static-2.650",
  "immer": "static-1.33",
  "laboratory-lib": "static-3.7187",
  "PortalIdParser": "static-2.404",
  "quartz-config": "static-1.847",
  "quartz-routing": "static-1.499",
  "quick-fetch": "static-1.3941",
  "react": "static-7.186",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.71",
  "react-rhumb": "static-1.16705",
  "react-select-plus": "static-1.105",
  "react-utils": "static-2.5369",
  "react-virtualized": "static-2.99",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "redux-toolkit": "static-1.7",
  "reselect": "static-2.16",
  "signup-constants": "static-1.18900",
  "signup-ui-lego-core": "static-1.20910",
  "styled-components": "static-2.89",
  "StyleGuideUI": "static-3.487",
  "ui-addon-react-router-dom": "static-1.9573",
  "ui-images": "static-2.1160",
  "UIComponents": "static-3.8450",
  "usage-tracker": "static-1.7379",
  "usage-tracker-core": "static-1.7229",
  "viral-links-lib": "static-1.7099",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.79",
  "metrics-js": "static-1.9637",
  "bend-plugin-trellis-migration": "static-1.3424",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3346",
  "quartz-webpack": "static-1.3293",
  "bend-plugin-quartz-routing": "static-1.147",
  "HeadJS": "static-2.764",
  "framer-motion": "static-1.72",
  "hs-test-utils-bend-plugin": "static-1.3157",
  "msw": "static-1.39",
  "testing-library": "static-1.152",
  "foundations-theming": "static-1.4451",
  "i18n-data": "static-1.221",
  "moment-timezone": "static-5.83",
  "jasmine": "static-4.4358",
  "dispatcher": "static-1.137",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.838",
  "hubspotter-http": "static-1.4676",
  "mobile-manifest-mixins": "static-1.538",
  "module-federation": "static-1.23",
  "quartz-auth": "static-1.744",
  "quartz-head": "static-1.734",
  "quartz-i18n": "static-1.744",
  "quartz-test": "static-1.744",
  "quartz-tracking": "static-1.448",
  "ui-fonts": "static-1.766",
  "usage-tracker-container": "static-1.7369",
  "sassPrefix": "static-1.156",
  "bend-plugin-foundations-components": "static-1.4263",
  "floating-ui": "static-1.56",
  "foundations-assets": "static-1.4900",
  "foundations-theming-specialty": "static-1.2167",
  "hs-story-utils": "static-1.9455",
  "react-aria": "static-1.66",
  "react-create-root-preference": "static-1.29",
  "tanstack-table": "static-1.55",
  "trellis-assets": "static-1.2036",
  "hs-locale-management": "static-1.106",
  "superstore": "static-1.4792",
  "csstype": "static-1.50",
  "web-vitals": "static-1.6",
  "rpc-client-utils": "static-1.4684",
  "emoji-regex": "static-1.7",
  "PatternValidationJS": "static-1.437",
  "signup-ui-url-generator": "static-2.8085",
  "bender-build-tools": "static-1.3227",
  "bend-plugin-foundations-theming": "static-1.2934",
  "foundations-theming-base": "static-1.3436",
  "stylex": "static-1.33",
  "hub-http-shared-msw-handlers": "static-1.10035",
  "hubspotter-http-shared-msw-handlers": "static-1.10033",
  "usage-tracker-session-replay": "static-1.5065",
  "bend-plugin-chirp-manifest": "static-1.94",
  "chirp-fetch": "static-1.1919",
  "ts-schema": "static-1.4105",
  "amplitude-session-replay-browser": "static-1.60"
},
  depPathPrefixes: {
  "embedded-viral-link-ui": "/embedded-viral-link-ui/static-1.6453",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8046",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "HubStyleTokens": "/HubStyleTokens/static-2.11504",
  "I18n": "/I18n/static-7.1631",
  "jasmine-runner": "/jasmine-runner/static-1.6495",
  "quartz": "/quartz/static-1.7069",
  "quartz-core": "/quartz-core/static-1.6288",
  "react-dlb": "/react-dlb/static-1.79",
  "webpack-env": "/webpack-env/static-1.54",
  "cssUtils": "/cssUtils/static-1.798",
  "enviro": "/enviro/static-4.455",
  "foundations-components": "/foundations-components/static-1.7994",
  "hub-http": "/hub-http/static-1.6254",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "HubStyle": "/HubStyle/static-2.11811",
  "icons": "/icons/static-2.650",
  "immer": "/immer/static-1.33",
  "laboratory-lib": "/laboratory-lib/static-3.7187",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "quartz-config": "/quartz-config/static-1.847",
  "quartz-routing": "/quartz-routing/static-1.499",
  "quick-fetch": "/quick-fetch/static-1.3941",
  "react": "/react/static-7.186",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.71",
  "react-rhumb": "/react-rhumb/static-1.16705",
  "react-select-plus": "/react-select-plus/static-1.105",
  "react-utils": "/react-utils/static-2.5369",
  "react-virtualized": "/react-virtualized/static-2.99",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "reselect": "/reselect/static-2.16",
  "signup-constants": "/signup-constants/static-1.18900",
  "signup-ui-lego-core": "/signup-ui-lego-core/static-1.20910",
  "styled-components": "/styled-components/static-2.89",
  "StyleGuideUI": "/StyleGuideUI/static-3.487",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9573",
  "ui-images": "/ui-images/static-2.1160",
  "UIComponents": "/UIComponents/static-3.8450",
  "usage-tracker": "/usage-tracker/static-1.7379",
  "usage-tracker-core": "/usage-tracker-core/static-1.7229",
  "viral-links-lib": "/viral-links-lib/static-1.7099",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.79",
  "metrics-js": "/metrics-js/static-1.9637",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3424",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3346",
  "quartz-webpack": "/quartz-webpack/static-1.3293",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.147",
  "HeadJS": "/HeadJS/static-2.764",
  "framer-motion": "/framer-motion/static-1.72",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3157",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.152",
  "foundations-theming": "/foundations-theming/static-1.4451",
  "i18n-data": "/i18n-data/static-1.221",
  "moment-timezone": "/moment-timezone/static-5.83",
  "jasmine": "/jasmine/static-4.4358",
  "dispatcher": "/dispatcher/static-1.137",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.838",
  "hubspotter-http": "/hubspotter-http/static-1.4676",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.538",
  "module-federation": "/module-federation/static-1.23",
  "quartz-auth": "/quartz-auth/static-1.744",
  "quartz-head": "/quartz-head/static-1.734",
  "quartz-i18n": "/quartz-i18n/static-1.744",
  "quartz-test": "/quartz-test/static-1.744",
  "quartz-tracking": "/quartz-tracking/static-1.448",
  "ui-fonts": "/ui-fonts/static-1.766",
  "usage-tracker-container": "/usage-tracker-container/static-1.7369",
  "sassPrefix": "/sassPrefix/static-1.156",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4263",
  "floating-ui": "/floating-ui/static-1.56",
  "foundations-assets": "/foundations-assets/static-1.4900",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2167",
  "hs-story-utils": "/hs-story-utils/static-1.9455",
  "react-aria": "/react-aria/static-1.66",
  "react-create-root-preference": "/react-create-root-preference/static-1.29",
  "tanstack-table": "/tanstack-table/static-1.55",
  "trellis-assets": "/trellis-assets/static-1.2036",
  "hs-locale-management": "/hs-locale-management/static-1.106",
  "superstore": "/superstore/static-1.4792",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.6",
  "rpc-client-utils": "/rpc-client-utils/static-1.4684",
  "emoji-regex": "/emoji-regex/static-1.7",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8085",
  "bender-build-tools": "/bender-build-tools/static-1.3227",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2934",
  "foundations-theming-base": "/foundations-theming-base/static-1.3436",
  "stylex": "/stylex/static-1.33",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10035",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10033",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5065",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.94",
  "chirp-fetch": "/chirp-fetch/static-1.1919",
  "ts-schema": "/ts-schema/static-1.4105",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60"
}
};
